<template>
  <div class="link">
    <div class="link-header">
      <img src="../assets/link-icon.png" class="link-header-icon" />
      <span class="link-header-title">友情链接</span>
    </div>
    <MarqueeText v-if="swiperList.length > 0" :duration="45" class="link-swiper">
      <span
        v-for="(item, index) in swiperList"
        :key="index"
        class="link-swiper-name"
        @click="golink(item.url)"
      >{{ item.name }}</span>
    </MarqueeText>
  </div>
</template>

<script>
import MarqueeText from "vue-marquee-text-component";

export default {
  data() {
    return {
      swiperList: []
    };
  },
  components: {
    MarqueeText
  },
  created() {
    this.getSwiperList();
  },
  methods: {
    getSwiperList() {
      this.$http.get("/setting/open").then(res => {
        this.swiperList = JSON.parse(res.data.data[0].blogroll);
      });
    },
    golink(link) {
      window.location.href = link;
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  height: 60px;
  line-height: 60px;
  margin-top: 16px;
  background: white;
  &-header {
    float: left;
    width: 120px;
    text-align: center;
    &-icon {
      vertical-align: middle;
      width: 16px;
      height: 16px;
    }
    &-title {
      color: #f08a3e;
      font-size: 16px;
      margin-left: 6px;
      vertical-align: middle;
      font-weight: 400;
    }
  }
  &-swiper {
    width: 1080px;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    font-size: 16px;
    text-align: initial;
    &-slide {
      width: 100%;
    }
    &-name {
      color: #1b97ff;
      padding: 0 30px;
      cursor: pointer;
    }
  }
}
</style>
